module.exports = __webpack_public_path__ + "img/4064007070.0a4f9fcc.jpg";